module.exports = __webpack_public_path__ + "static/media/express-original-wordmark.f1a0b0e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/express-original-wordmark.svg
// module id = 97
// module chunks = 0